import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(({ isDark }) =>
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    paddingBottom: [0, 'l'],
    height: ['calc(100vh - 120px)', 'calc(80vh - 140px)'],
    bg: isDark ? '#000' : 'default',
  }),
);

themeStyles.addBaseStyles('Content')(
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: ['start', 'center'],
    paddingLeft: ['20px', 0],
    paddingRight: ['20px', 0],
    gap: '16px',
    flex: 1,
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    fontSize: ['28px', '28px', '44px'],
    width: ['60%', '100%'],
    fontWeight: '200',
    textTransform: 'none',
    lineHeight: ['32px', '32px', '50px'],
    a: {
      textDecoration: 'none',
    },
  }),
);

themeStyles.addBaseStyles('CTASection')(
  css({
    display: 'flex',
    flexDirection: ['column', 'row'],
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    backgroundColor: 'white',
    paddingTop: ['50px', '0px'],
    width: '100%',
    boxShadow: ['0px -2px 4px rgba(0, 0, 0, 0.15)', 'none'],
  }),
);

themeStyles.addBaseStyles('Description')(
  css({
    fontFamily: 'default',
    fontSize: '16px',
    lineHeight: 'md',
    letterSpacing: '0.5px',
    '& a': {
      height: 'auto',
    },
  }),
);

export default themeStyles;
